<template>
  <RouterView v-if="me" :me="me" />
  <div v-else-if="error" class="m-8" data-testid="authorized-area-error">
    <MessageBanner type="error" :headline="t('ErrorViews.InitializationError.title')">
      <pre class="bg-transparent text-body-m whitespace-pre-wrap">{{ error.message }}</pre>
      <button
        class="mt-4 rounded-lg border border-current px-4 py-2 text-body-m hover:opacity-80"
        data-testid="authorized-area-retry-button"
        @click="refetch()"
      >
        {{ t('ErrorViews.InitializationError.tryAgain') }}
      </button>
    </MessageBanner>
  </div>
</template>

<script lang="ts">
export default {
  name: 'AuthorizedArea',
  inheritAttrs: false,
  customOptions: {},
}
</script>

<script setup lang="ts">
import { MessageBanner } from '@ramp106/omrjs-core-ui'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { useMeQuery } from '@/gql/myomr'
import { useReviewsCurrentUserQuery } from '@/gql/reviews'
import { setFeatureFlagPartnerCompany } from '@/services/posthog'
import { useMeStore } from '@/stores'
const { t } = useI18n()
const { setupCurrentUser, identifyUser } = useMeStore()

const { result, error, onResult, refetch } = useMeQuery()
onResult((queryResult) => {
  if (queryResult.loading) return
  if (queryResult?.data) {
    const data = queryResult.data
    setupCurrentUser(data)
    setFeatureFlagPartnerCompany(data.me?.partnerCompany?.slug)
  }
})

const { onResult: onReviewsCurrentUserResult } = useReviewsCurrentUserQuery({ clientId: 'reviews' })
onReviewsCurrentUserResult((queryResult) => {
  if (queryResult.loading) return
  identifyUser(queryResult.data?.manage?.currentUser ?? undefined)
})

const me = computed(() => result.value?.me)
</script>
